import { useEffect, useState } from "react";
import heyflowBannerImage from "@/assets/new-heyflow-banner.png";
import heyflowBannerImageWebP from "@/assets/new-heyflow-banner.webp";

// Track if Heyflow script is already loaded
let heyflowScriptLoaded = false;

const HeyflowBanner = () => {
  const [isHeyflowLoaded, setIsHeyflowLoaded] = useState(false);

  // Load Heyflow script only when user clicks the banner
  const loadHeyflowScript = () => {
    if (!heyflowScriptLoaded && !isHeyflowLoaded) {
      // Check if script already exists in DOM
      const existingScript = document.querySelector('script[src*="heyflow.com"]');
      if (!existingScript) {
        heyflowScriptLoaded = true;
        setIsHeyflowLoaded(true);
        
        const script = document.createElement('script');
        script.src = 'https://assets.prd.heyflow.com/builder/widget/latest/webview.js';
        script.defer = true;
        document.head.appendChild(script);
        
        // Wait for script to load before opening modal
        script.onload = () => {
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent('heyflow-modal-element:open', { 
              detail: { modalId: 'u_9gsDM9sg' }
            }));
          }, 100);
        };
      } else {
        setIsHeyflowLoaded(true);
        // Script already exists, open modal immediately
        window.dispatchEvent(new CustomEvent('heyflow-modal-element:open', { 
          detail: { modalId: 'u_9gsDM9sg' }
        }));
      }
    } else if (isHeyflowLoaded) {
      // Script already loaded, open modal immediately
      window.dispatchEvent(new CustomEvent('heyflow-modal-element:open', { 
        detail: { modalId: 'u_9gsDM9sg' }
      }));
    }
  };

  const openHeyflow = () => {
    loadHeyflowScript();
  };

  return (
    <>
      {/* Heyflow Modal Element */}
      <div 
        dangerouslySetInnerHTML={{
          __html: `<heyflow-modal-element modal-id="u_9gsDM9sg"><heyflow-wrapper flow-id="leitfaden-v2" dynamic-height scroll-up-on-navigation style-config='{"width":"100%"}' modal-id="u_9gsDM9sg"></heyflow-wrapper></heyflow-modal-element>`
        }}
      />

      {/* Clickable Banner Section */}
      <section className="py-8 md:py-12 bg-muted/40">
        <div className="container-comfortable">
          <div className="max-w-4xl mx-auto">
            <button
              onClick={openHeyflow}
              className="w-full block transition-transform hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded-xl"
              aria-label="Lebenslanges Wohnrecht gratis ermitteln - Heyflow öffnen"
            >
              <picture>
                <source 
                  srcSet={heyflowBannerImageWebP} 
                  type="image/webp"
                  sizes="(max-width: 640px) 100vw, (max-width: 1024px) 90vw, 896px"
                />
                <img 
                  src={heyflowBannerImage}
                  alt="Lebenslanges Wohnrecht gratis ermitteln deutschlandweit für Eigentümer"
                  className="w-full rounded-xl shadow-lg hover:shadow-xl transition-shadow"
                  loading="lazy"
                  width="896"
                  height="469"
                  sizes="(max-width: 640px) 100vw, (max-width: 1024px) 90vw, 896px"
                />
              </picture>
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeyflowBanner;